import { axios } from '../util/axios'
import { getQueryParams } from '../util/uri'

const API_ENDPOINT = '/v0/user/passwordless_send_email'

export default email => {
  const data = { email, redirectParams: getQueryParams() }
  return axios
    .post(API_ENDPOINT, data, {
      withCredentials: true,
    })
    .then(response => response.data)
}
